// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"1d0324c4","269":"5b5b0978","487":"9cd1e431","524":"e8968482","860":"6a51ec20"}[chunkId] + ".chunk.js";
};